import { IDLE } from "../../global/statusLabels";
import { CHECK_SCREENING_CL_SUCCESS, GET_COLLECTION_CENTER_BY_LEVEL_CL_SUCCESS, GET_DECLINE_REASONS_CL_SUCCESS, GET_GEOLOCATIONS_SUCCESS, RESET_SCREENING_COLON_RETTO_STATE } from "./actionsType";

const initialState = {
    checkScreeningCL: { value: undefined, status: IDLE },
    declineReasonsCL: { value: undefined, status: IDLE },
    collectionCenterCL: { value: undefined, status: IDLE },
    geoLocationsCollectionCenterCL: { value: undefined, status: IDLE },
}

export const screeningColonRettoReducer = (state = initialState, action) => {
    switch (action.type) {

        case CHECK_SCREENING_CL_SUCCESS:
            return {
                ...state,
                checkScreeningCL: action.payload
            }
        case GET_DECLINE_REASONS_CL_SUCCESS:
            return {
                ...state,
                declineReasonsCL: action.payload
            }
        case GET_COLLECTION_CENTER_BY_LEVEL_CL_SUCCESS:
            return {
                ...state,
                collectionCenterCL: action.payload
            }
        case GET_GEOLOCATIONS_SUCCESS:
            return {
                ...state,
                geoLocationsCollectionCenterCL: action.payload
            }
        case RESET_SCREENING_COLON_RETTO_STATE:
            return initialState

        case 'persist/REHYDRATE':
            return state;

        default:
            return state;
    }
}